import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import BalanceIcon from '../assets/icons/balance.svg';
import BuildIcon from '../assets/images/build.svg';
import BurnIcon from '../assets/images/burn.svg';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';

interface IProps {
  t: (str: string) => string;
}
const viewBox = '0 0 25 50';
const iconWidth = '100%';
const iconHeight = '100%';

export const InfluencerLearnMorePartTwo = ({ t }: IProps) => {
  return (
    <>
      <Text style={[styles.normalText, styles.textMarginBottom]}>
        {t('workoutChoiceQuestionSubHeading')}
      </Text>
      <Text style={[styles.normalText, styles.textMarginBottom]}>
        {t('workoutChoiceDescriptionPartOne')}
        <Text style={styles.boldText}>
          {t('workoutChoiceDescriptionPartTwo')}
        </Text>
        {t('workoutChoiceDescriptionPartThree')}
        <Text style={styles.boldText}>
          {t('workoutChoiceDescriptionPartFour')}
        </Text>
        {t('workoutChoiceDescriptionPartFive')}
        <Text style={styles.boldText}>
          {t('workoutChoiceDescriptionPartSix')}
        </Text>
      </Text>
      <View style={styles.iconAndTextContainer}>
        <View style={styles.iconContainer}>
          <BurnIcon width={iconWidth} height={iconHeight} viewBox={viewBox} fillSecondary={'#231F20'} />
        </View>
        <Text style={[styles.normalText, styles.textMarginBottom]}>
          <Text style={styles.boldText}>
            {t('burnWorkoutsDescriptionPartOne')}
          </Text>
          {t('burnWorkoutsDescriptionPartTwo')}
        </Text>
      </View>
      <View style={styles.iconAndTextContainer}>
        <View style={styles.iconContainer}>
          <BuildIcon width={iconWidth} height={iconHeight} viewBox={viewBox} fillSecondary={'#231F20'} />
        </View>
        <Text style={[styles.normalText, styles.textMarginBottom]}>
          <Text style={styles.boldText}>
            {t('buildWorkoutsDescriptionPartOne')}
          </Text>
          {t('buildWorkoutsDescriptionPartTwo')}
        </Text>
      </View>
      <View style={styles.iconAndTextContainer}>
        <View style={styles.iconContainer}>
          <BalanceIcon width={iconWidth} height={iconHeight} viewBox={viewBox} fillSecondary={'#231F20'} />
        </View>
        <Text style={styles.normalText}>
          <Text style={styles.boldText}>
            {t('balanceWorkoutsDescriptionPartOne')}
          </Text>
          {t('balanceWorkoutsDescriptionPartTwo')}
        </Text>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  normalText: {
    ...Theme.textStyle.bodyCopyReg,
  },
  iconContainer: {
    width: defaultScale(25),
    height: defaultScale(50),
    marginRight: defaultScale(10),
    marginTop: defaultScale(10),
  },
  boldText: {
    ...Theme.textStyle.bodyCopyBold,
  },
  textMarginBottom: {
    marginBottom: defaultScale(25),
  },
  iconAndTextContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingRight: defaultScale(25),
  },
});
